const ALLOWED = ['light', 'dark']

const setCookie = (value) => {
  const maxAge = 60 * 60 * 24 * 365
  document.cookie = `mdm_theme=${value}; Path=/; Max-Age=${maxAge}; SameSite=Lax`
}

const applyTheme = (value) => {
  if (!ALLOWED.includes(value)) return
  document.documentElement.setAttribute('data-theme', value)
  if (document.body) document.body.setAttribute('data-theme', value)
  setCookie(value)
}

const render = (container, activeMode, status) => {
  container.querySelectorAll('[data-theme-option]').forEach((btn) => {
    const mode = btn.dataset.themeOption
    const active = mode === activeMode
    btn.classList.toggle('btn-primary', active)
    btn.classList.toggle('btn-default', !active)
    btn.setAttribute('aria-pressed', active ? 'true' : 'false')
  })
  const statusEl = container.querySelector('[data-theme-status]')
  if (statusEl) statusEl.textContent = status || ''
}

const persist = async (value) => {
  const csrf = document.querySelector('meta[name="csrf-token"]')
  const response = await fetch('/admin/api/v2/preferences', {
    method: 'PATCH',
    credentials: 'same-origin',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrf ? csrf.getAttribute('content') : ''
    },
    body: JSON.stringify({ theme: value })
  })
  if (!response.ok) throw new Error(`HTTP ${response.status}`)
  return response
}

export const wireThemeToggles = () => {
  const containers = document.querySelectorAll('[data-theme-settings]')
  containers.forEach((container) => {
    if (container.dataset.themeSettingsInit === 'true') return
    container.dataset.themeSettingsInit = 'true'

    container.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-theme-option]')
      if (!button || !container.contains(button)) return
      const value = button.dataset.themeOption
      if (!ALLOWED.includes(value)) return
      const previous = document.documentElement.getAttribute('data-theme') || 'light'
      if (value === previous) return

      applyTheme(value)
      render(container, value, 'Saving…')
      try {
        await persist(value)
        render(container, value, 'Saved.')
      } catch (_error) {
        applyTheme(previous)
        render(container, previous, 'Could not save theme. Please try again.')
      }
    })
  })
}
